import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const Advisors = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const advisorsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/advisors',
    name: 'advisors',
    component: Advisors,
    meta: {
      title: 'Asesores',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/advisors',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
